/**
 * SHELL — transient toast notifications. Accessible (aria-live), auto-dismiss.
 */

import { el } from './dom';

let host: HTMLElement | null = null;
let hideTimer = 0;

function ensureHost(): HTMLElement {
  if (host && host.isConnected) return host;
  host = el('div', { class: 'dr-toast', role: 'status', ariaLive: 'polite' });
  document.body.appendChild(host);
  return host;
}

/** Show a short message. Replaces any visible toast. */
export function toast(message: string, durationMs = 2600): void {
  const node = ensureHost();
  node.textContent = message;
  // Force reflow so the transition replays even on repeat calls.
  void node.offsetWidth;
  node.classList.add('dr-toast--show');
  window.clearTimeout(hideTimer);
  hideTimer = window.setTimeout(() => {
    node.classList.remove('dr-toast--show');
  }, durationMs);
}
